import * as HttpRequest from "EstruturaAntiga/assets/httpRequest";
import ProdutosService from "services/ProdutosService";

export async function checkBundleLimit(bundleId){
  const userSignature = HttpRequest.userSignature();
  const validacaoDisponibilidadePlanoDTO = {
    tenantCode: userSignature.tenantCode,
    produtoPacoteId: bundleId,
    quantidadeSolicitada: 1
  }

  let bundleLimit = { licencaDisponivel: false };
  await ProdutosService.ValidarDisponibilidadeDaLicencaPorPacote(validacaoDisponibilidadePlanoDTO)
    .then(() => {
      bundleLimit.licencaDisponivel = true;
    })
    .catch(error => {
      bundleLimit.licencaDisponivel = false;
      bundleLimit.mensagem = error.response?.data?.erros[0] ?? 'Erro ao validar plano. Favor entre em contato com nosso atendimento.';
    })

  return bundleLimit;
}
